import React, { Component } from 'react';
import Enum from './Enum.js'
import Message from './Message.js'
import Service from './Service.js'
import Package from './Package.js'
import ScalarValueType from './ScalarValueType.js'

class Descriptor extends Component {
    render() {
        switch (this.props.descriptor.kind) {
            case "service":
                return <Service descriptor={this.props.descriptor.service} />
            case "message":
                return <Message descriptor={this.props.descriptor.message} />
            case "enum":
                return <Enum descriptor={this.props.descriptor.enum} />
            case "package":
                return <Package descriptor={this.props.descriptor.package} />
            case "scalarValueType":
                return <ScalarValueType descriptor={this.props.descriptor.scalarValueType} />
            default:
                return null;
        }
    }
}

export default Descriptor;



// WEBPACK FOOTER //
// ./src/reference/Descriptor.js